module.exports = __webpack_public_path__ + "static/media/clio-logo.093b1ae7.png";